import { render, staticRenderFns } from "./en.vue?vue&type=template&id=83b5f914&scoped=true&"
import script from "./en.vue?vue&type=script&lang=js&"
export * from "./en.vue?vue&type=script&lang=js&"
import style0 from "./en.vue?vue&type=style&index=0&id=83b5f914&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b5f914",
  null
  
)

export default component.exports